import { apiSlice } from "./apiSlice";

export const relationshipApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getRelations: builder.query({
      query: ({ type, id }) => ({
        url: "/api/relations/",
        params: { type, id },
      }),
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useGetRelationsQuery, useLazyGetRelationsQuery } = relationshipApiSlice;
